import React, { useContext, useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import styled from 'styled-components/native';
import DataTable from '@preflighttech/preflight-tables';
import moment from 'moment';

import AuthContext from 'app/src/contexts/AuthContext';
import { MainContainer, ContentContainer } from 'app/src/elements';
import minimalTable from 'app/src/elements/minimalTable';
import { downloadReport } from 'app/src/elements/ReportDownload';
import { PAST_SALES } from 'app/src/components/Sales/queries';
import { useParams } from 'app/src/utils/routing';

const Title = styled(Text)`
  font-weight: 600;
  margin-bottom: 20px;
`;

const TitleText = styled(Text)`
  font-size: 16px;
  font-weight: 600;
`;

export const DownloadLinks = ({ sale, handleDownload }) => {
  const [downloading, setDownloading] = useState();

  return (
    <View style={{flexDirection: 'row', gap: 20}}>
      <Pressable
        onPress={() => (
          handleDownload({ saleId: sale.id, type: 'xlsx', setDownloading })
        )}
      >
        <Text>
          {'xlsx' === downloading ? 'Downloading...' : 'Download Excel'}
        </Text>
      </Pressable>
      <Pressable
        onPress={() => (
          handleDownload({ saleId: sale.id, type: 'pdf', setDownloading })
        )}
      >
        <Text>
          {'xlsx' === downloading ? 'Downloading...' : 'Download PDF'}
        </Text>
      </Pressable>
    </View>
  );
};

const PastSaleReports = ({ saleId }) => {
  const { user, credentials } = useContext(AuthContext);

  const { data } = useQuery(PAST_SALES);
  let sales = data?.pastSales || [];
  if (saleId) {
    sales = sales.filter(sale => sale.id === saleId);
  }

  const handleDownload = ({ saleId: downloadSaleId, ...downloadProps }) => {
    downloadReport({
      ...downloadProps,
      credentials,
      path: 'sales-report',
      params: { 'sale-id': downloadSaleId, 'seller-id': user.seller.id },
    });
  };

  const columns = [
    {
      key: 'saleOn',
      label: 'Date',
      sort: 'prevent',
      width: 90,
      content: ({ value }) => moment(value).format('M/D/YYYY'),
    },
    {
      key: 'name',
      label: 'Sale Name',
      sort: 'prevent',
    },
    {
      key: 'downloads',
      label: 'Download',
      sort: 'prevent',
      content: ({ entry }) => (
        <DownloadLinks sale={entry} handleDownload={handleDownload} />
      )
    },
  ];

  return (
    <MainContainer>
      <ContentContainer>
        <Title>
          <TitleText>Past Sale Reports</TitleText>
        </Title>
        <DataTable.Simple
          data={sales}
          columns={columns}
          component={minimalTable}
          pageLength="All"
        />
      </ContentContainer>
    </MainContainer>
  );
};

export default PastSaleReports;
